<div class="dashboard-progress res-assign-block" fxFlex="0 1 100%">
    <app-sticky-header
        class="sticky-header"
        [title]="data.customer.name"
        context="Specify resources to"
        contextIcon="checklist"
        (onSubmit)="onSubmit()"
        (onCancel)="bottomSheetRef.dismiss()"
    ></app-sticky-header>

    <mat-tab-group #tabGroup class="dashboard-tabs mt-1">
        <mat-tab label="Courses" i18n-label="@@courses" style="max-height: 100%">
            <ng-template matTabContent>
                <ng-container
                    [ngTemplateOutlet]="selectTemp"
                    [ngTemplateOutletContext]="{
                        label: 'Number of courses',
                        scope: AppScope.COURSE
                    }"
                ></ng-container>
            </ng-template>
        </mat-tab>
        <mat-tab label="Material" i18n-label="@@material" style="max-height: 100%">
            <ng-template matTabContent>
                <ng-container
                    [ngTemplateOutlet]="selectTemp"
                    [ngTemplateOutletContext]="{
                        label: 'Number of materials',
                        scope: AppScope.MATERIAL
                    }"
                ></ng-container>
            </ng-template>
        </mat-tab>
        <mat-tab label="Tests" i18n-label="@@tests" style="max-height: 100%">
            <ng-template matTabContent>
                <ng-container
                    [ngTemplateOutlet]="selectTemp"
                    [ngTemplateOutletContext]="{
                        label: 'Number of tests',
                        scope: AppScope.TEST
                    }"
                ></ng-container>
            </ng-template>
        </mat-tab>
        <mat-tab label="Surveys" i18n-label="@@surveys" style="max-height: 100%">
            <ng-template matTabContent>
                <ng-container
                    [ngTemplateOutlet]="selectTemp"
                    [ngTemplateOutletContext]="{
                        label: 'Number of surveys',
                        scope: AppScope.SURVEY
                    }"
                ></ng-container>
            </ng-template>
        </mat-tab>
        <mat-tab label="SCORM" i18n-label="@@SCORM" style="max-height: 100%">
            <ng-template matTabContent>
                <ng-container
                    [ngTemplateOutlet]="selectTemp"
                    [ngTemplateOutletContext]="{
                        label: 'Number of SCORMs',
                        scope: AppScope.SCORM
                    }"
                ></ng-container>
            </ng-template>
        </mat-tab>
        <mat-tab label="E-courses" i18n-label="@@ecourses" style="max-height: 100%">
            <ng-template matTabContent>
                <ng-container
                    [ngTemplateOutlet]="selectTemp"
                    [ngTemplateOutletContext]="{
                        label: 'Number of e-courses',
                        scope: AppScope.E_COURSE
                    }"
                ></ng-container>
            </ng-template>
        </mat-tab>

        <mat-tab label="Packages" i18n-label="@@packages" style="max-height: 100%">
            <ng-template matTabContent>
                <ng-container
                    [ngTemplateOutlet]="selectTemp"
                    [ngTemplateOutletContext]="{
                        label: 'Number of packages',
                        scope: AppScope.PACKAGE
                    }"
                ></ng-container>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
    <ng-template #selectTemp let-label="label" let-scope="scope">
        <app-scoped-resource-select-manager
            [columns]="['select', 'title', 'created_by', 'updated_at']"
            [selectionLabel]="label"
            [scope_id]="scope"
            [prefLangIds]="data.customer.pref_lang_ids"
            referenceFilter="referenceCluster"
            [referencePropertyValue]="data.referencePropertyValue"
            [defaultSorting]="data.customer.id ? 'checked' : 'name'"
            [customer_id]="data.customer.id"
            [accessForm]="controlByScope(scope, 'referenceCluster')"
            i18n-selectionLabel
            sync_all_key="sync_all"
            attachKey="attach_ids"
            detachKey="detach_ids"
            class="user-manager-res-select"
        ></app-scoped-resource-select-manager>
    </ng-template>
</div>

<!-- <app-resources-assign
    [data]="data.customer"
    [referencePropertyValue]="data.referencePropertyValue"
    context="Specify resources to"
    contextIcon="checklist"
    [referenceProperty]="data.referenceProperty"
    (onCancel)="bottomSheetRef.dismiss()"
    (onSave)="bottomSheetRef.dismiss($event)"
></app-resources-assign> -->
